import { L } from '@execonline-inc/translations';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { ScheduledProgramInstanceOption } from '../../../../../Types';
import { utcDateToLocalDate } from '../../../../Functions';
import Store from '../Store';

interface Props {
  scheduledOption: ScheduledProgramInstanceOption;
  store: Store;
  selectable: boolean;
}

function DateCheckbox({ scheduledOption, store, selectable }: Props) {
  return (
    <label className="flex mt-4 items-center w-fit">
      <input
        className={clsx({
          'h-5 w-5 text-teal-600 mr-2 rounded': true,
          'cursor-pointer': selectable,
          'opacity-50 cursor-default bg-gray-200': !selectable,
        })}
        disabled={!selectable}
        type="checkbox"
        name="Add Program"
        checked={store.selectedIds.includes(scheduledOption.id)}
        onChange={() => store.selectProgram(scheduledOption)}
      />
      <L
        localizeable={utcDateToLocalDate(scheduledOption.startOn)}
        format={'long-weekday-month-year'}
      />
    </label>
  );
}

export default observer(DateCheckbox);
